export * from './tab-bar.component'
